import { isHex as thirdwebIsHex } from 'thirdweb'

export const isHex = thirdwebIsHex
